<template>
  <v-tooltip bottom>
    <template #activator="{on, attrs}">
      <div v-on="on" v-bind="attrs" class="sap-badge-wrapper d-inline-flex align-center">
        <div class="bg-sap sap-badge d-inline-block"></div>
      </div>
    </template>
    SAP
  </v-tooltip>
</template>

<script>
export default {
  name: 'AppSAPBadge'
};
</script>

<style scoped>
.sap-badge-wrapper {
  height: 100% !important;
}
.sap-badge {
  clip-path: polygon(0 0, 100% 0, 49% 100%, 0% 100%);
  background: linear-gradient(#00b9f2, #019ce0, #0c7ecf, #1661be);
  color: white;
  padding-left: 0.05rem;
  width: 2rem;
  height: 1rem;
}
</style>
